import React from 'react'

export function PagingLight(props) {

    const { LastPage, CurrentPage, OnPageChange, pagingData } = props;

    return (
        <>

            {props.children}

            <div className="message-footer clearfix" style={{ padding: "0px 16px" }}>
                <div className="pull-left">
                    <h6 style={{ marginTop: "25px" }}>
                        {pagingData &&
                            (pagingData.firstItemOnPage) + " - " + (pagingData.lastItemOnPage) + " of " + (pagingData.totalItemCount) + "  (Page " + pagingData.pageNumber + " of " + pagingData.pageCount + ")"
                        }
                    </h6>
                </div>

                <div className="pull-right" style={{ margin: "-5px" }}>

                    <ul className="pager">
                        <li className="previous" >

                            <button disabled={(LastPage == 1 || LastPage == 0) ? true : (CurrentPage == 1 ? true : false)} className="btn btn-white btn-info" value={parseInt(CurrentPage) - 1} onClick={OnPageChange}>←</button>

                        </li>

                        <li className="next" >

                            <button disabled={(LastPage == 1 || LastPage == 0) ? true : (CurrentPage == LastPage ? true : false)} style={{ marginLeft: "20px" }} className="btn btn-white btn-info" value={parseInt(CurrentPage) + 1} onClick={OnPageChange}>→</button>

                        </li>
                    </ul>
                </div>
            </div>
        </>


    )
}
